export function UpIcon() {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="48" height="48" rx="16" fill="white"/>
      <path d="M24 29.8334V18.1667" stroke="#A4AABF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M18.1665 24.0001L23.9998 18.1667L29.8332 24.0001" stroke="#A4AABF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}